import { t } from "ttag";

import type { UserAttributes } from "./types";

export const PUERTO_RICO_STATE_VALUE = "PR" as const;

export const REFILL_TYPE = {
  ASYNC: "async",
  SYNC: "sync",
} as const;

export const PHONE_NUMBERS = {
  MEDICAL_ISSUES: {
    NUMBER: "(539) 867 7741",
    TEL_HREF: "tel:+15398677741",
  },
  CUSTOMER_SUPPORT: {
    NUMBER: "(689) 225 1671",
    TEL_HREF: "tel:+16892251671",
  },
} as const;

/**
 * @deprecated use the one from /domains
 */
export const AVAILABLE_LANGUAGE = {
  EN: "en",
  ES: "es",
} as const;

export const GENDER = {
  MALE: "male",
  FEMALE: "female",
} as const;

export const getGenderLabel = (gender: UserAttributes["gender"]) => {
  return {
    [GENDER.MALE]: t`Male`,
    [GENDER.FEMALE]: t`Female`,
  }[gender];
};

export const AGE_LIMIT = {
  MIN: 18,
  MAX: 74,
  LONGEVITY_MIN: 25,
} as const;

export const ERROR_CODES = {
  HEALTHIE_ERROR: "healthie_error",
  UNAVAILABLE_TIME_SLOT: "unavailable_time_slot",
} as const;

export const UNIT_SYSTEM = {
  METRIC: "metric",
  IMPERIAL: "imperial",
} as const;

export const WEIGHT_UNIT = {
  [UNIT_SYSTEM.METRIC]: "kg",
  [UNIT_SYSTEM.IMPERIAL]: "lb",
} as const;

export const getUnitSystemOptions = () =>
  [
    {
      label: t`Imperial`,
      unit: t`inches`,
      value: UNIT_SYSTEM.IMPERIAL,
    },
    {
      label: t`Metric`,
      unit: t`cm`,
      value: UNIT_SYSTEM.METRIC,
    },
  ] as const;

export const CURRENCY = {
  USD: "usd",
} as const;

export const MAX_ENTRY_NOTE_CHARACTERS = 110;

export const MAX_WEIGHT_LBS = 1000;

export const MAX_WEIGHT_KG = 454;

export const MAX_HEIGHT_FEET = 8;
export const MAX_HEIGHT_INCHES = 11;
export const MAX_HEIGHT_CENTIMETERS = 250;

export const COUNTRY = {
  US: "US",
} as const;
